/***************************************************************************************************
 * MENU.JS
 *
 * @author      N.K
 * @package     メニュー関連（ヘッダーメニュー）
 * @subpackage
 * @copyright
 * @since       2021/06/08
 * @link
***************************************************************************************************/
import { insteadDialog } from '../Common/dialog';

$(function ()
{
    // 変数受取
    var $script = $('#CommonMenuScript');

    //************************************************************************************************
    // 定数定義（引数）
    //************************************************************************************************


    //************************************************************************************************
    // 変数定義（引数）
    //************************************************************************************************
    var ajax_search_instead = JSON.parse($script.attr('data-ajax_search_instead')); // ajax用

    var instead_cnt = JSON.parse($script.attr('data-instead_cnt'));
    var instead_flg = JSON.parse($script.attr('data-instead_flg'));
    var relevance_list = JSON.parse($script.attr('data-relevance_list'));



    //************************************************************************************************
    // 定数定義（フィールド）
    //************************************************************************************************


    //************************************************************************************************
    // 変数定義（フィールド）
    //************************************************************************************************


    //************************************************************************************************
    // 関数定義
    //************************************************************************************************
    //================================================================================================
    // メイン関数　※最初に記載！
    //================================================================================================
    var main = function ()
    {
        // 代行操作先 検索初期化
        ajaxSearchInsteadUsers(null, null);
    };

    //================================================================================================
    // モバイル判定処理
    //================================================================================================
    var mobilecheck = function ()
    {
        var check = false;
        (function (a)
        {
            if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            {
                check = true;
            }
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };
    var clickevent = mobilecheck() ? "touchstart" : "click";

    //================================================================================================
    // メニューテキストリンク押下時
    //================================================================================================
    $('.menu-link').on('click', function (e)
    {
        $('.submenu-inner').removeClass('submenu-inner');
        var type = $(this).data("type");
        console.log('type = ' + type);

        if (type != "logout")
        {
            $('.submenu').removeClass('submenu-close').addClass('submenu-open');
            $('.submenu').find('li').css('display', 'none');
            $('.submenu').find('li.' + type).css('display', '');
            // 表示位置調整
            $('.submenu').css({
                'left': $(this).offset().left + 'px',
            });
        }

        // ログアウト時
        if (type == "logout")
        {
            location.href = $('#logout_link').attr("href");
        }
    });



    //=============================================================================================
    // スマホ・タブレットメニュー（ハンバーガー）
    //=============================================================================================
    $('#menu_hamburger_btn').on('click', function ()
    {

        $(this).find("a").toggleClass("active");
        $('.submenu').toggleClass('submenu-open');

        if ($('.submenu').hasClass('submenu-open'))
        {
            $('.submenu ul').addClass('submenu-inner');
            $('.submenu-inner').scrollTop();

            $('.submenu').removeClass('submenu-close').addClass('submenu-open');
            $('.submenu').find('li').css('display', '');
            $('.submenu').css({
                'left': '14px',
            });
            $('html').css({
                'overflow-y': 'hidden'
            });
        }
        else
        {
            $('.submenu').find('li').css('display', 'none');
            $("html").css({
                'overflow-y': 'scroll'
            });
        }
    });

    //================================================================================================
    // 代行操作用リンク押下時
    //================================================================================================
    $('.instead_link').on('click', function (e)
    {
        var is_instead = true;
        var is_relevance = true;
        if(!(instead_cnt != 0 || instead_flg == true))
        {
            is_instead = false;
        }

        if(relevance_list.length == 0)
        {
            is_relevance = false;
        }
        var title = '';
        if(is_instead == true && is_relevance == true)
        {
            title = '代行操作先・関連ユーザー選択画面';
        }
        else if(is_instead == true)
        {
            title = '代行操作先選択画面';
        }
        else if(is_relevance == true)
        {
            title = '関連ユーザー選択画面';
        }
        // モーダルを開く
        var result = insteadDialog(title, null, function ()
        {
            // モーダル側でリストより選択した代行操作先情報(種別＋ID)をフォームへ設定する
            $('#instead_type').val($('#select_instead_user_modal').find('#select_instead_user_modal_user_name option:selected').data('type'));
            $('#instead_id').val($('#select_instead_user_modal').find('#select_instead_user_modal_user_name').val());

            return false;
        });

        if(is_instead == true && is_relevance == true)
        {
            // 権限2つともあり
            document.getElementById('warning_msg2').classList.add('d-none');
        }
        else if(is_instead == true)
        {
            // 代行操作のみ権限あり
            document.getElementById('warning_msg2').classList.add('d-none');
            document.getElementById('warning_msg3').classList.add('d-none');
            document.getElementById('relevance').classList.add('d-none');

            // ラジオボタンは非表示
            document.getElementById('radio_instead').classList.add('d-none');
        }
        else if(is_relevance == true)
        {
            // 関連ユーザーのみ権限あり
            document.getElementById('warning_msg1').classList.add('d-none');
            document.getElementById('warning_msg3').classList.add('d-none');
            document.getElementById('instead').classList.add('d-none');
            document.getElementById('radio_relevance').checked = true;

            // ラジオボタンは非表示
            document.getElementById('radio_relevance').classList.add('d-none');
        }

        return result;
    });

    $('#modal_ok_btn').on('click', function (e)
    {
        const radios = document.getElementsByName('option');
        let selectedValue;
        for (const radio of radios) {
            if (radio.checked) {
                selectedValue = radio.value;
                break;
            }
        }
        if(selectedValue == '代行操作先名')
        {
            document.getElementById('instead_id').value = document.getElementById('select_instead_user_modal_user_name').value;
            var selected_option = document.getElementById('select_instead_user_modal_user_name').options[document.getElementById('select_instead_user_modal_user_name').selectedIndex];
            var data_type = selected_option.getAttribute('data-type');
            document.getElementById('instead_type').value = data_type;

            $('#execute_instead').trigger('click');
        }
        else if(selectedValue == '関連ユーザー')
        {
            document.getElementById('relevance_id').value = document.getElementById('select_relevance_user_modal_user_name').value;
            $('#execute_relevation').trigger('click');
        }
    });

    //================================================================================================
    // 代行操作先選択ダイアログ 代行操作先取得用 Ajax用関数
    //================================================================================================
    function ajaxSearchInsteadUsers(instead_name, address1)
    {
        $('#select_instead_user_modal_user_name').prop('disabled', true);

        $.ajax({
            url: ajax_search_instead,
            type: 'POST',
            data: {
                'instead_name': instead_name,
                'address1': address1,
            }
        })
            // 成功時
            .done((data) =>
            {
                $('.select_instead_user_modal_user_name_options').remove();
                $.each(data, function (index, value)
                {
                    if (value.login_user_flag == true)
                    {
                        // 代行操作先リストでログインユーザの場合
                        $('#select_instead_user_modal_user_name').append(
                            '<option class="select_instead_user_modal_user_name_options" value="' + value.id + '" data-type="' + value.type + '" data-name="' + value.name + '">' + value.name + ' 【ログイン中】</option>'
                        );

                    } else
                    {
                        // 代行操作先リストでログインユーザ以外の場合
                        $('#select_instead_user_modal_user_name').append(
                            '<option class="select_instead_user_modal_user_name_options" value="' + value.id + '" data-type="' + value.type + '" data-name="' + value.name + '">' + value.name + '</option>'
                        );
                    }
                })

                // データが0の時
                if (data.length == 0)
                {
                    $('#select_instead_user_modal_user_name').prop('disabled', true);
                }
                else
                {
                    $('#select_instead_user_modal_user_name').prop('disabled', false);
                }
            })
            // 失敗時
            .fail((data) =>
            {
                console.log('false');
            })
    }

    //================================================================================================
    // 画面クリック時
    //================================================================================================
    $(document).on("click touchend", function (e)
    {

        if ($("#sp_header_menu_area").css("display") == "none")
        {
            //if (!$(e.target).closest("#menu_wrap").length)
            if (!$(e.target).closest("#menu_wrap .main-menu-items .menu-link").length)
            {
                // サブメニュー表示⇒非表示
                $('.submenu').removeClass('submenu-open').addClass('submenu-close');
                $('.submenu').find('li').css('display', 'none');
            }
        }
    });

    //=============================================================================================
    // リサイズ時
    //=============================================================================================
    $(window).on('resize', function ()
    {
        if (screen.width > 992)
        {
            $("html").css({
                'overflow-y': 'scroll'
            });
            $('.submenu').removeClass('submenu-open');
            $('#menu_hamburger_btn').find("a").removeClass("active");
        }
        else
        {
            if ($("#sp_header_menu_area").css("display") == "none")
            {
                $("html").css({
                    'overflow-y': 'scroll'
                });
                // サブメニュー表示⇒非表示
                $('.submenu').removeClass('submenu-open');
                $('#menu_hamburger_btn').find("a").removeClass("active");
                $('.submenu').find('li').css('display', 'none');
            }
        }
        // PC
        // else
        // {
        //     $('.submenu').removeClass('submenu-open');
        //     $('#menu_hamburger_btn').find("a").removeClass("active");
        // }
    });

    //************************************************************************************************
    // メイン関数呼び出し
    //************************************************************************************************
    main();
});



